import * as Sentry from '@sentry/react'
import { switchPlan } from '../services/manage'

export const handle3DSecureAuthentication = async (stripe, paymentData, onSuccess, onError) => {
  if (!stripe) {
    onError('Stripe is not initialized')
    return
  }

  try {
    const result = await stripe.confirmCardPayment(paymentData.payment_intent.client_secret)

    if (result.error) {
      onError(result.error.message)
    } else if (result.paymentIntent.status === 'succeeded') {
      onSuccess({
        paymentIntentId: result.paymentIntent.id,
        subscriptionId: paymentData.subscription_id,
        customerId: paymentData.customer_id
      })
    } else {
      onError(`Unexpected payment status: ${result.paymentIntent.status}`)
    }
  } catch (error) {
    onError(error.message || '3D Secure authentication failed')
  }
}

export const handle3DSecure = async (stripe, paymentData, email, onSuccessCallback, onError) => {
  if (!stripe) {
    onError('Payment system is not ready. Please try again.')
    return
  }

  await handle3DSecureAuthentication(
    stripe,
    paymentData,
    async (confirmationData) => {
      try {
        await switchPlan({
          email,
          isConfirmation: true,
          paymentIntentId: confirmationData.paymentIntentId,
          subscriptionId: confirmationData.subscriptionId,
          customerId: confirmationData.customerId
        })

        if (onSuccessCallback) {
          onSuccessCallback()
        }
      } catch (error) {
        Sentry.captureException(error, {
          tags: {
            section: '3ds-confirmation-error'
          }
        })
        onError('Failed to confirm payment. Please contact support.')
      }
    },
    (errorMessage) => {
      onError(errorMessage)
    }
  )
}
